<template>

	<v-content>
		<v-container fluid fill-height>
			<v-layout row>


				<v-flex xs12 sm6 offset-sm3>
					<v-card>
						<template v-if="isLoading">
							<div class="text-xs-center pa-5">
								<v-progress-circular :size="50" color="indigo" indeterminate></v-progress-circular>
								<div class="caption mt-4">Domain listesi yükleniyor</div>
							</div>
						</template>
						<template v-if="!isLoading">
							<v-toolbar color="indigo" dark>
								<v-toolbar-title>Kullanıcı Grupları</v-toolbar-title>
								<v-spacer></v-spacer>
								<v-btn icon @click="openEditor(false)">
									<v-icon>add_circle</v-icon>
								</v-btn>
							</v-toolbar>


							<v-list>
								<template v-for="(group, groupIndex) in groups">
									<v-list-tile :key="groupIndex" avatar @click="openEditor(group)">
										<v-list-tile-content>
											<v-list-tile-title> {{group.group_name}} </v-list-tile-title>
										</v-list-tile-content>
									</v-list-tile>
								</template>
							</v-list>
						</template>
					</v-card>
				</v-flex>


				<v-dialog v-model="dialogEditor" fullscreen hide-overlay transition="dialog-bottom-transition">
					<v-toolbar dark color="secondary">
						<v-btn icon dark @click="dialogEditor = false">
							<v-icon>close</v-icon>
						</v-btn>
						<v-toolbar-title v-if="editGroup.id">Grubu Düzenle</v-toolbar-title>
						<v-toolbar-title v-if="!editGroup.id">Grup Ekle</v-toolbar-title>
						<v-spacer></v-spacer>
						<v-toolbar-items>
							<v-btn dark flat color="white" @click="saveGroup()">Save</v-btn>
						</v-toolbar-items>
					</v-toolbar>
					<v-card v-if="dialogEditor"> 
						<v-card-text class="pl-4 pr-4 EditorWrapper">
							<v-layout wrap>
								<v-flex xs12 >
									<v-text-field v-model="editGroup.group_name" label="Grubun Adı" hide-details outline
										class="mb-3"></v-text-field>
								</v-flex>
								<v-flex xs12 >
									<b>Yetkiler</b>
									<template v-for="(auth, authIndex) in authlist">
										<v-checkbox :key="authIndex" v-model="editGroup.auths" :label="auth.text"
											:value="auth.link" hide-details class="mt-0" color="indigo"></v-checkbox>
										<template v-if="auth.children">
											<template v-for="(child, childIndex) in auth.children">
												<v-checkbox :key="childIndex" v-model="editGroup.auths"
													:label="child.text" :value="child.link" hide-details
													class="mt-0 ml-4" color="indigo"></v-checkbox>
											</template>
										</template>
									</template>
								</v-flex>
							</v-layout>
						</v-card-text> 
					</v-card>
				</v-dialog>







			</v-layout>
		</v-container>
	</v-content>


</template>


<script>
	export default {
		name: "UsersGroupsIndex",
		components: {},
		data() {
			return {
				isLoading: true,
				dialogEditor: false,
				authlist: [],
				groups: [],
				editGroup: {}

			}
		},
		mounted() {
			this.loadAuthList();
		},
		methods: {
			loadAuthList() {
				this.isLoading = true;
				this.$http.get(process.env.VUE_APP_API_URL + "/users/groups/auth_list", {
					params: {}
				}).then(response => {
					this.authlist = response.body;
					this.loadGroups()
				})
			},
			loadGroups() {
				this.isLoading = true;
				this.$http.get(process.env.VUE_APP_API_URL + "/users/groups", {
					params: {}
				}).then(response => {
					this.groups = response.body;
					this.isLoading = false;
				})
			},
			openEditor(item) {
				if (item) {
					this.editGroup = JSON.parse( JSON.stringify(item) );
				} else {
					this.editGroup = {
						id: "",
						group_name: "",
						auths: []
					}
				}
				this.dialogEditor = true;
			},
			saveGroup() {
				this.dialogEditor = false;
				this.$http.post(process.env.VUE_APP_API_URL + "/users/groups/save", this.editGroup, {
					params: {}
				}).then(response => {
					this.user = response.body;
					this.loadGroups();
				})
			}
		},
		computed: {

		}
	}
</script>



<style lang="less">
	.EditorWrapper{
		width : 400px;
		max-width : calc(~"100% - 20px");
		margin:0px auto;
	}
</style>
